import {EventEditor} from "./EventEditor.js";

export class WaitNodeEditor extends EventEditor {

	constructor(parent, node, coords) {
		super(parent, node, coords);
	}

	/**
	 * @param {CanvasRenderingContext2D} ctx
	 */
	draw(ctx) {
		super.draw(ctx);
		ctx.save();
		ctx.strokeStyle = this.selected ? S.HI_COLORS[8] : "black";
		const lw = this.lineWidth;
		ctx.lineWidth = lw;
		ctx.beginPath();
		ctx.ellipse(this.coords.x, this.coords.y, (this.coords.w - 8 - lw) / 2, (this.coords.h -8 - lw) / 2, 0, 0, 2 * Math.PI);
		ctx.stroke();
		let hand = (this.coords.w -8 - 4*lw)/2;
		ctx.lineCap = "round";
		ctx.beginPath();
		ctx.moveTo(this.coords.x, this.coords.y);
		ctx.lineTo(this.coords.x + hand * Math.cos(Math.PI/-3), this.coords.y + hand * Math.sin(Math.PI/-3));
		ctx.stroke();
		hand -= 2*lw;
		ctx.lineWidth = lw * 1.2;
		ctx.beginPath();
		ctx.moveTo(this.coords.x, this.coords.y);
		ctx.lineTo(this.coords.x + hand * Math.cos(Math.PI/4), this.coords.y + hand * Math.sin(Math.PI/4));
		ctx.stroke();
		ctx.restore();
	}

}